import React from 'react';
import DashboardV2 from './DashboardV2';
import DashboardLight from './DashboardLight';
import DashboardDark from './DashboardDark';
import useDashboardData from '../hooks/useDashboardData';
import useDashboardTheme from '../hooks/useDashboardTheme';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import TeknisiQuickActions from './TeknisiQuickActions';
import MikrotikStatusWidget from '../components/MikrotikStatusWidget';  // 2026-07-15: dashboard teknisi
import OwnerBalanceCard from '../components/OwnerBalanceCard';  // 2026-08-22: owner balance widget

/**
 * Renders the active dashboard variant based on theme selection.
 * Theme switching, accent picker & auto day/night controls live in
 * the user menu (Layout.jsx) — single source of truth via
 * useDashboardTheme + localStorage.
 */
const DashboardWrapper = () => {
  const dashboardData = useDashboardData();
  const { baseVariant } = useDashboardTheme();

  let DashboardComp;
  switch (baseVariant) {
    case 'light': DashboardComp = DashboardLight; break;
    case 'dark':  DashboardComp = DashboardDark;  break;
    case 'glass':
    default:      DashboardComp = DashboardV2;    break;
  }

  const { user } = useAuth();
  const _role = (user?.role || '').toLowerCase();
  // 2026-07-08: voucher_agent has dedicated dashboard
  if (_role === 'voucher_agent') {
    return <Navigate to="/app/agent-dashboard" replace />;
  }
  const isTeknisi = _role === 'teknisi';

  // 2026-07-15: Role teknisi punya dashboard khusus (Dashboard.jsx) — bukan
  // DashboardV2/Light/Dark yang mengandung widget-widget yang butuh permission
  // lebih tinggi (branches, tenants, revenue chart, dst) → hasil banyak area kosong.
  // Teknisi cukup lihat: 3 stats card (Total PPPoE, Online, Offline) + MikrotikStatusWidget.
  if (isTeknisi) {
    // 2026-07-15: Dashboard khusus teknisi — TeknisiQuickActions (4 stats cards +
    // link ke halaman terkait) + MikrotikStatusWidget (status router).
    // Tidak render Dashboard.jsx supaya tidak ada gap kosong dari min-h-screen
    // loader dan duplikat data.
    return (
      <div data-dashboard-root className="px-4 py-4 space-y-4">
        <TeknisiQuickActions stats={dashboardData?.stats} />
        <div className="max-w-6xl">
          <MikrotikStatusWidget />
        </div>
      </div>
    );
  }

  // Match dashboard surface bg so the teknisi quick-actions strip doesn't
  // show a white gap above the dashboard (especially on dark themes).
  const wrapperStyle = baseVariant === 'dark'
    ? { background: 'radial-gradient(ellipse at top, #1e293b 0%, #0b1120 60%)' }
    : baseVariant === 'glass'
      ? { background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 25%, #f5f3ff 50%, #ede9fe 75%, #f0f9ff 100%)' }
      : undefined;

  const _isOwner = _role === 'owner';
  return (
    <div data-dashboard-root style={wrapperStyle}>
      {_isOwner && (
        <div className="px-4 pt-4">
          <OwnerBalanceCard />
        </div>
      )}
      <DashboardComp {...dashboardData} />
    </div>
  );
};

export default DashboardWrapper;
